(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-animations"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('main .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('site-anim-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section, index) {
      if (index === 0) return;
      section.classList.add('site-anim-reveal', 'site-anim-ready');
      section.style.transitionDelay = Math.min(index * 60, 240) + 'ms';
      observer.observe(section);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
